module.exports = __webpack_public_path__ + "img/item-3.b991dc5.png";